// removed by extract-text-webpack-plugin
module.exports = {"attendee-list":"_3Z9Hi9tCH _2l0xl0HVf _3cWZ9MSKx _1C3le7ltj _3n87MdY-3 _3uKzqKb8t APZH6AEYZ OIsiVUT2J _2X0mllu17 bHDRqtlU2 rgQ1hO_KM _3hAOedd31 _2zVYNxcNW _1t9KApSC5 _2E9qGyV4u xBrMYP3IH _1d2RkWR4_","header":"ZpSq498f8 _2gtf48bQr ZJzW3NgDp _3o46ocWJM _14cC-qpf- n83gu3eXn bwE6sz9x8 _2hFSao6ex pVX-un-3M _2vBo870CX uzkr4mcRp _2FyRbnyPA _2e7pE4Whn _4Q7tK2JYu _1r6VaDdEj _1pfV688Si","attendee":"OdEiej0vg _2sGa7qNeF"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/attendee-list/attendee-list.css
 ** module id = 2084
 ** module chunks = 0
 **/